export enum FromComponentTypes {
	TABS='from-tabs',
	CAROUSEL='from-carousel'
}
